import {
  CAMPAIGN_AND_LEAD_QUERY_PARAM_IDS,
  CART_ID_PARAM_ID,
  PRODUCT_ID_PARAM_ID,
  UPDATE_ADVICE_QUERY_PARAM_ID,
} from "Constants/queryParams";

import { isDefined } from "Utils/functions";
import { QueryParams } from "./queryParameterTypes";

export const getQueryString = (queryParams: URLSearchParams): string => {
  const queryString = filterUndefinedParams(queryParams).toString();
  if (queryString.length > 0) {
    return `?${queryString}`;
  }
  return "";
};

export const getMergedQueryParams = (
  paramsList: (QueryParams | undefined)[],
): URLSearchParams =>
  filterUndefinedParams(
    paramsList
      .map((params) => new URLSearchParams(params).entries())
      .flatMap((params) => Array.from(params))
      .reduce((mergedParams, [key, value]) => {
        mergedParams.set(key, value);
        return mergedParams;
      }, new URLSearchParams()),
  );

const filterUndefinedParams = (params: QueryParams): URLSearchParams => {
  const filteredParams = new URLSearchParams(params);
  filteredParams.forEach((value, key) => {
    if (value === "undefined") {
      filteredParams.delete(key);
    }
  });
  return filteredParams;
};

export const getUpdateAdviceQueryParam = (): URLSearchParams =>
  new URLSearchParams({ [UPDATE_ADVICE_QUERY_PARAM_ID]: "true" });

export const getCampaignAndLeadQueryParams = (): URLSearchParams =>
  filterParamsWithIds(
    CAMPAIGN_AND_LEAD_QUERY_PARAM_IDS,
    window.location.search,
  );

const filterParamsWithIds = (
  paramIds: string[],
  params: QueryParams,
): URLSearchParams => {
  const queryParams = new URLSearchParams(params);
  const filteredParams = paramIds
    .map((paramId) => [paramId, queryParams.get(paramId)])
    .filter((entry): entry is [string, string] => isDefined(entry[1]));
  return new URLSearchParams(filteredParams);
};

export const getProductEditQueryParams = (
  params: string = window.location.search,
): {
  cartId: string | null;
  productId: string | null;
} => {
  const queryParams = new URLSearchParams(params);
  const cartId = queryParams.get(CART_ID_PARAM_ID);
  const productId = queryParams.get(PRODUCT_ID_PARAM_ID);
  return { cartId, productId };
};

export const withoutProductEditParams = (
  params: QueryParams | undefined,
): URLSearchParams => {
  const updatedParams = new URLSearchParams(params);
  if (updatedParams.has(CART_ID_PARAM_ID)) {
    updatedParams.delete(CART_ID_PARAM_ID);
  }
  if (updatedParams.has(PRODUCT_ID_PARAM_ID)) {
    updatedParams.delete(PRODUCT_ID_PARAM_ID);
  }
  return updatedParams;
};
